import { URL_HOLIDAY_BANNER_CLOSE } from '@tools/routes/routes';

export const initHolidayBanner = () => {
  if (!document.getElementById('holiday-banner')) {
    return;
  }

  window.addEventListener('load', () => {
    const banner = document.getElementById('holiday-banner');
    if (!banner) {
      return;
    }
    const closeBanner = () => {
      banner.remove();
    };
    banner.querySelector('.hb-c__close').addEventListener('click', closeBanner);
    banner.querySelector('button').addEventListener('click', () => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', URL_HOLIDAY_BANNER_CLOSE);
      xhr.send();
      closeBanner();
    });
  });
};
